<template>
  <div>
    <el-form ref="form"
      @keyup.enter.native="submit"
      :rules="rules" :model="form"
      onSubmit="return false;" >
      <el-form-item prop="password" :label="$t('loginPage.passwordLabel')">
        <el-input
          v-model="form.password"
          type="password"
          data-test="password-input"
          :placeholder="$t('loginPage.passwordLabel')"
          autofocus=autofocus>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          v-loading="loading"
          data-test="submit-button"
          type="primary"
          @click="submit">
          {{ $t('loginPage.submitButtonText') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      autofocus: true,
      loading: false,
      rules: {
        password: [
          {
            required: true,
            message: this.$t('commons.fieldRequiredMessage'),
            trigger: 'blur',
          },
        ],
      },
      form: {
        password: '',
      },
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('passwordTry', this.form.password);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
